var parent = require('../../es/instance/starts-with');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/stable/instance/starts-with.js
// module id = 1121
// module chunks = 0